import imgData from '../imgData';

const get = async () => imgData;

export default {
    get,
}